import i18n from '@/i18n'
import {makeStep} from "../../utils";
import {requireAssetWithFallback} from "@/utils";

const grommetColor = (curtainTemplate, curtainType) => {
  //get from api available grommet colors
  //at this moment is not available
  // const availableColors = curtainTemplate.available_colors
  const availableColors = ['agedsilver', 'black']

  if (
    curtainType !== "ringcurtain"
    || !availableColors
    || !availableColors.length
  ) {
    return null
  }
  return {
    id: 'ring_type',
    name: i18n.t("components.stepper.grommetColor.title"),
    type: 'card',
    choices: availableColors.map(availableColor => ({
      title: i18n.t(`enums.GrommetColor.${availableColor}`),
      value: availableColor,
      imgSrc: requireAssetWithFallback(`images/grommet_color/${availableColor}.jpg`),
    }))
  }
}

export default (curtainTemplate, curtainType) => {
  const stepQuestions = [
    grommetColor(curtainTemplate, curtainType),
  ]
  return makeStep(stepQuestions, i18n.t("components.stepper.grommetColor.title"))
}
